import type { Language } from './data.ts';

const knownFemale = new Set(['Samantha','Karen','Moira','Tessa','Veena','Fiona','Zuzana','Sara','Laila','Mageda','Nora','Joana','Ava','Allison','Susan','Serena','Amira']);
const knownMale = new Set(['Daniel','Alex','Fred','Rishi','Thomas','Oliver','Aaron','Majed','Tariq']);

export interface VoiceInfo { voice: SpeechSynthesisVoice; identity: 'known female' | 'known male' | null }

export function voiceIdentity(name: string): VoiceInfo['identity'] {
  const first = name.split(/[ (]/)[0];
  if (knownFemale.has(first)) return 'known female';
  if (knownMale.has(first)) return 'known male';
  return null;
}

export function voicesFor(language: Language): VoiceInfo[] {
  if (!('speechSynthesis' in window)) return [];
  const prefix = language === 'ar' ? 'ar' : 'en';
  return speechSynthesis.getVoices().filter((v) => v.lang.toLowerCase().startsWith(prefix)).map((voice) => ({ voice, identity: voiceIdentity(voice.name) })).sort((a, b) => Number(b.voice.localService) - Number(a.voice.localService) || (a.identity === 'known female' ? -1 : 0) || a.voice.name.localeCompare(b.voice.name));
}

export function selectVoice(language: Language, selected: string | null): SpeechSynthesisVoice | undefined {
  const choices = voicesFor(language);
  return choices.find(({ voice }) => voice.voiceURI === selected)?.voice ?? choices.find(({ voice, identity }) => voice.localService && identity === 'known female')?.voice ?? choices.find(({ voice }) => voice.localService)?.voice ?? choices[0]?.voice;
}

export function speak(text: string, language: Language, selected: string | null, rate: number, onEnd?: () => void): boolean {
  if (!text.trim() || !('speechSynthesis' in window)) return false;
  speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = language === 'ar' ? 'ar-SA' : 'en-US';
  utterance.rate = rate;
  const voice = selectVoice(language, selected);
  if (voice) { utterance.voice = voice; utterance.lang = voice.lang; }
  if (onEnd) { utterance.onend = onEnd; utterance.onerror = onEnd; }
  speechSynthesis.speak(utterance);
  return true;
}

export const stopSpeech = () => { if ('speechSynthesis' in window) speechSynthesis.cancel(); };

